<section class="filtering-section">
  <app-selected-filters
    [selectedFilters]="selectedFacets"
    [searchRequest]="searchRequest"
    (unselectFacet)="refreshSearchResult($event)"
  ></app-selected-filters>
  <div
    class="col-md-12"
    class="refinement"
    *ngIf="!!totalRecords && !!filterNavigation?.length"
    #refinement
  >
    <section>
      <div *ngFor="let filterNav of filterNavigation">
        <app-refinement-menu
          [filterNav]="filterNav"
          [searchRequest]="searchRequest"
          (selectFilterOption)="refreshSearchResult($event)"
        ></app-refinement-menu>
        <app-static-refinement-menu
          [filterNav]="filterNav"
        ></app-static-refinement-menu>
        <app-range-refinement-menu
          [filterNav]="filterNav"
          [searchRequest]="searchRequest"
          (selectRangeFilterOption)="refreshSearchResult($event)"
        ></app-range-refinement-menu>
      </div>
    </section>
  </div>
</section>
